import SearchField from '../../components/common/searchField';
import Selector from '../../components/common/selector';
import './style.scss';

import React, { useState, useEffect } from 'react';
import GenericTable from "../../components/common/genericTable";
import {useDispatch, useSelector} from "react-redux";

import {
  clearCreateUserAlerts, clearFetchUsersErrors,
  clearManagedUser,
  clearSaveUserProfileAlerts,
  clearSendInviteAlerts,
  fetchUsers,
  goToUserProfile,
  sendInviteEmail,
  sendInvites,
  setManagedUser
} from "../../actions/users";
import {setLiveRegionText} from "../../actions/app";
import Alert from "../../components/common/alert";
import {DEFAULT_RESULTS_PER_PAGE, MESSAGES} from "../../constants";
import SendInvite from "./sendInvite";
import ConfirmDialog from '../../components/common/confirmDialog';
import ResultsCount from "../../components/common/resultsCount";
import Pagination from "../../components/common/pagination";
import ResultsPerPage from "../../components/common/resultsPerPage";
import LinkButton from "../../components/common/linkButton";
import {Navigate, redirect, useNavigate} from "react-router-dom";
import {route as CREATE_USER_ROUTE} from "../createUser";
import LoadingSpinner from "../../components/common/loadingSpinner";
import {setLoadingStatus} from "../../actions/session";
import {getLockedOrExpiredErrorMessage} from "../../utils/session";

export const route = 'users';

const PERMISSIONS = [
  {
    label: 'All Permissions',
    value: ''
  },
  {
    label: 'Super User',
    value: 'Super User'
  },
  {
    label: 'Administrator',
    value: 'Administrator'
  },
  {
    label: 'Account Manager',
    value: 'Account Manager'
  },
  {
    label: 'Batch User',
    value: 'Batch Viewer'
  },
  {
    label: 'Report Viewer',
    value: 'Report User'
  }
];

const SCHOOLS = [
  {
    label: 'All Schools',
    value: ''
  },
  {
    label: 'District',
    value: 1
  },
  {
    label: 'County',
    value: 2
  },
  {
    label: 'University',
    value: 3
  },
];


const columns =  [
  {name: 'sendInvite', label: 'Send Invites'},
  {name: 'first-and-last-name', label: 'Name', sortable: true},
  {name: 'username', label: 'Email', sortable: true},
  //This is the Permission Level name, not the user's name
  {name: 'name', label: 'Permission Level', sortable: true},
  {name: 'schoolName', label: 'School(s)', sortable: true},
  {name: 'invitationDeliveryDate', label: 'Invite Sent', sortable: true},
  {name: 'lastLoginDate', label: 'Last Login', sortable: true}
];

const ManageUsers = (props) => {
  const searchMessage = 'Search completed.';
  const filterMessage = 'Filter applied.';

  const managedUser = useSelector((state) => state.users.managedUser);

  const [schoolFilter, setSchoolFilter] = useState('');
  const [permissionsFilter, setPermissionsFilter] = useState('');
  const [searchFilter, setSearchFilter] = useState('');
  const [liveRegionMessage, setLiveRegionMessage] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [resultsPerPage, setResultsPerPage] = useState(DEFAULT_RESULTS_PER_PAGE);
  const [showInviteConfirmation, setShowInviteConfirmation] = useState(false);
  const [inviteeInfo, setInviteeInfo] = useState(null);
  let emptyMessage = MESSAGES.GENERIC_TABLE.noDataAvailable;

  const firstItem = (currentPage === 1) ? 0 : (currentPage - 1) * resultsPerPage;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const currentUser = useSelector((state) => state.session.currentUser);

  useEffect(() => {
    async function loadUsers()  {
      await dispatch(setLoadingStatus(true));
      await dispatch(fetchUsers());
      await dispatch(clearManagedUser());
      await dispatch(clearSaveUserProfileAlerts());
      await dispatch(setLoadingStatus(false));
    }

    loadUsers();
  }, [dispatch]);

  function sendInviteForUser(selectedUser) {
    dispatch(sendInviteEmail(currentUser.username, selectedUser.username));
  }

  const users = useSelector((store) => store.users.users);
  const fetchUsersError = useSelector((store) => store.users.fetchUsersError);
  const isLoading = useSelector((store) => store.session.isLoading);

  const sendInviteSuccess = useSelector((state) => state.users.sendInviteSuccess);
  const sendInviteApiError = useSelector((state) => state.users.sendInviteApiError);
  const createUserSuccess = useSelector((state) => state.users.createUserSuccess);
  const saveUserPermissionsSuccess = useSelector((state) => state.users.saveUserPermissionsApiSuccess)

  let userPermissionsMessage = MESSAGES.USERS.savePermissionsSuccess;

  if (createUserSuccess && saveUserPermissionsSuccess) {
    userPermissionsMessage = MESSAGES.USERS.createUserSuccess;
  }

  let fullLiveRegionMessage = '';

  const schoolList = users.map((item) => {
    const displaySchoolName = (item.schoolName === null) ? 'N/A' : item.schoolName;
    return {label: displaySchoolName, value: displaySchoolName}
  });

  function filterAndSortSchoolList(schoolList) {
    let schoolNames = [];

    const filteredSchoolList = schoolList.filter((item) => {
      if (item.value === null) {
        return false;
      }

      if (schoolNames.find(element => element === item.value)) {
        return false;
      } else {
        schoolNames.push(item.value);
      }

      return true;
    });

    filteredSchoolList.sort((a, b) => {
      if (a.value === 'N/A') {
        return -1;
      }

      if (b.value === 'N/A') {
        return 1;
      }

      if (a.value > b.value) {
        return 1;
      }

      if (a.value < b.value) {
        return -1;
      }

      return 0;
    });

    filteredSchoolList.unshift({label: 'All Schools', value: 0});

    return filteredSchoolList;
  }



  function checkFilters(item) {
     const name = `${item.firstName} ${item.lastName}`;

     if (searchFilter) {
       const searchTerm = searchFilter.toLowerCase();

       if (name.toLowerCase().indexOf(searchTerm) < 0 && item.username.toLowerCase().indexOf(searchTerm) < 0) {
         return false;
       }
     }

     if (permissionsFilter && permissionsFilter !== item.name) {
       return false;
     }

     if (schoolFilter && schoolFilter !== '0') {
       if (schoolFilter === 'N/A' && item.schoolName !== null) {
          return false;
       } else if (schoolFilter !== 'N/A' && schoolFilter !== item.schoolName) {
         return false;
       }
     }

     return true;
  }

  const pageItems = () => {
    return filteredItems.slice(firstItem, lastItem());
  }

  const resultsFirstItem = () => {
    return (filteredItems.length > 0) ? firstItem + 1 : 0;
  }

  const lastItem = () => {
    if (filteredItems.length <= resultsPerPage) {
      return filteredItems.length;
    } else {
      const lastItem = parseInt(firstItem) + parseInt(resultsPerPage);

      return (lastItem <= filteredItems.length) ? lastItem: filteredItems.length;
    }
  }

  const sendAction = (currentUser, item) => {
    setInviteeInfo(item)
    setShowInviteConfirmation(true);
  }

  const handleConfirmSendInviteEmail = () => {
    setShowInviteConfirmation(false);
    dispatch(sendInviteEmail(currentUser, inviteeInfo));
  }

  function filterTable(filterAction, filterValue, newLiveRegionMessage) {
    filterAction(filterValue);
    setLiveRegionMessage(newLiveRegionMessage);
    setCurrentPage(1);
  }

  const clickUserName = (item) => {
    dispatch(clearCreateUserAlerts());
    dispatch(setManagedUser(item.username));
    navigate('/user-profile');
  }

  const clickNewUser = () => {
    dispatch(clearCreateUserAlerts());
    navigate('/create-user');
  }
  const formatCell = (item, column) => {
    switch (column.name) {
      case 'first-and-last-name':
        return (
          <LinkButton clickAction={() => clickUserName(item)} label={`${item['firstName']} ${item['lastName']}`}/>
        );
      case 'invitationDeliveryDate':
        return formatInviteSent(item[column['name']]);
      case 'schoolName':
        return formatSchoolName(item['schoolName']);
      case 'lastLoginDate':
        return formatLastLoginDate(item['lastLoginDate']);
      case 'name':
        return formatPermissionLevel(item['name']);
      default:
        return item[column['name']];
    }
  }

  function addInvite(item, idx, isChecked = false) {
    const name = `sendInvite-${idx}`;
    const id = `send-invite-button-${idx}`;

    return <SendInvite name={name} id={id} item={item} currentUser={currentUser} sendAction={(currentUser, userToInvite) => sendAction(currentUser, userToInvite)} />
  }

  function addInvites(items) {
    return items.map((item, idx) => {
      item.sendInvite = addInvite(item, idx);

      return item;
    });
  }

  function prepareColumns () {
    return columns.map((column) => {
      switch (column.name) {
        case 'first-and-last-name':
        case 'name':
        case 'schoolName':
        case 'invitationDeliveryDate':
        case 'lastLoginDate':
          column.onDisplay = (item, column) => {
            return formatCell(item, column);
          };
          return column;
        default:
          return column;
      }
    });
  }

  const [sortColumn, setSortColumn] = useState('name');
  const [sortDirection, setSortDirection] = useState('');

  function compareSortValues(sortValueA, sortValueB, basicCharsOnly = false) {
    let valueA = sortValueA;
    if ((typeof sortValueA === 'string') && basicCharsOnly) {
      valueA = sortValueA.toLowerCase().replace(/\W/g, '');
    }

    let valueB = sortValueB;
    if ((typeof sortValueB === 'string') && basicCharsOnly) {
      valueB = sortValueB.toLowerCase().replace(/\W/g, '');
    }

    if (valueA === null) {
      return (sortDirection === 'ascending') ? 1 : -1;
    }

    if (valueB === null) {
      return (sortDirection === 'ascending') ? -1 : 1;
    }

    if (valueA < valueB) {
      return (sortDirection === 'ascending') ? 1 : -1;
    }
    if (valueA > valueB) {
      return (sortDirection === 'ascending') ? -1 : 1;
    }

    return 0;
  }

  function formatInviteSent(invitationDeliveryDate) {
    return (invitationDeliveryDate) ? 'Yes' : 'No';
  }

  function formatSchoolName(schoolName) {
    return (schoolName) ? schoolName : 'N/A';
  }

  function formatPermissionLevel(permissionLevelName) {
    const thisPermissionLevel = PERMISSIONS.find((permission) => permission.value === permissionLevelName);

    if (!thisPermissionLevel) {
      return "N/A";
    }

    return thisPermissionLevel.label;
  }

  function formatLastLoginDate(lastLoginDate) {
    const todaysDate = new Date();
    const todaysDateString = `${todaysDate.getFullYear()}-${todaysDate.getMonth()}-${todaysDate.getUTCDate()}`;

    if (!lastLoginDate) {
      return 'Never';
    }

    const loginDate = new Date(lastLoginDate);

    if (lastLoginDate === todaysDateString) {
      return 'Today';
    }

    if (loginDate) {
      return new Intl.DateTimeFormat("en-US", {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(loginDate);
    }


  }

  function sortUsers(a, b) {
    switch(sortColumn) {
      case 'first-and-last-name':
        return compareSortValues(`${a.firstName} ${a.lastName}`, `${b.firstName} ${b.lastName}`, true);
      case 'invitationDeliveryDate':
        const inviteSentA = formatInviteSent(a.invitationDeliveryDate);
        const inviteSentB = formatInviteSent(b.invitationDeliveryDate);

        return compareSortValues(inviteSentA, inviteSentB);
      case 'schoolName':
        const schoolNameA = formatSchoolName(a.schoolName);
        const schoolNameB = formatSchoolName(b.schoolName);

        return compareSortValues(schoolNameA, schoolNameB, true);
      case 'lastLoginDate':
        return compareSortValues(a[sortColumn], b[sortColumn]);
      default:
        return compareSortValues(a[sortColumn], b[sortColumn], true);
    }
  }

  function processUsers() {
    let filteredItems = users.filter(checkFilters);

    let sortedItems = (sortDirection) ? filteredItems.sort(sortUsers) : filteredItems;

    if (liveRegionMessage) {
      fullLiveRegionMessage = `${liveRegionMessage} ${sortedItems.length} results returned`;
    }

    if (users.length !== filteredItems.length && filteredItems.length === 0) {
      emptyMessage = MESSAGES.GENERIC_TABLE.noResultsFound;
    }

    return addInvites(sortedItems);
  }

  const filteredItems = processUsers();

  const totalPages = Math.ceil((filteredItems.length / resultsPerPage));

  function changeSort(newSortDirection, newSortColumn) {
    setSortDirection(newSortDirection);

    if (newSortColumn !== sortColumn) {
      setSortColumn(newSortColumn);
    }
  }

  useEffect(() => {
    if (fullLiveRegionMessage) {
      dispatch(setLiveRegionText(fullLiveRegionMessage));
    }
  });

  return (isLoading) ? <LoadingSpinner/> : (
    <div className="main-content">
      <div className='manage-users-alerts'>
        {(fetchUsersError) && <Alert messageType='error' onDismiss={() => dispatch(clearFetchUsersErrors())}>{MESSAGES.USERS.fetchUsersError}</Alert>}
        {(sendInviteSuccess) && <Alert messageType='success' onDismiss={() => dispatch(clearSendInviteAlerts())}>{`${MESSAGES.USERS.sendInviteSuccess} ${sendInviteSuccess.username}`}</Alert>}
        {(sendInviteApiError) && <Alert messageType='error' onDismiss={() => dispatch(clearSendInviteAlerts())}>{getLockedOrExpiredErrorMessage(sendInviteApiError, MESSAGES.SEND_INVITE)}</Alert>}
        {(createUserSuccess || saveUserPermissionsSuccess) && <Alert messageType='success' onDismiss={() => dispatch(clearCreateUserAlerts())}>{userPermissionsMessage}</Alert>}
      </div>
      <div>
        {(inviteeInfo) && <ConfirmDialog
          showModal={showInviteConfirmation}
          title='Send Email Invitation'
          message={`You are about to send an email invitation to <span class='invitee-name'>${inviteeInfo.firstName} ${inviteeInfo.lastName}</span>, would you like to continue?`}
          showCancelButton={true}
          onDismiss={() => setShowInviteConfirmation(false)}
          onConfirm={handleConfirmSendInviteEmail}
        />}
      </div>
      <div className='manage-users-header'>Manage Users</div>
      <div className="manage-users-container">
        <div className="table-controls">
          <div className="users-controls">
            <SearchField
              label='Search users'
              placeholder='Search users'
              submitAction={(searchValue) => {filterTable(setSearchFilter, searchValue, searchMessage)}}
            />
            <Selector
              name="permissions"
              value={permissionsFilter}
              changeAction={(filterValue) => {filterTable(setPermissionsFilter, filterValue, filterMessage)}}
              items={PERMISSIONS}
            />
            <Selector
              name="schools"
              value={schoolFilter}
              changeAction={(filterValue) => {filterTable(setSchoolFilter, filterValue, filterMessage)}}
              items={filterAndSortSchoolList(schoolList)}
            />
            <button className='tes-button' onClick={() => clickNewUser()}>+ New User</button>
          </div>
        </div>
        <ResultsPerPage value={resultsPerPage} changeAction={setResultsPerPage} />
        <div className='table-container'>
          <GenericTable tableData={pageItems()} cols={prepareColumns(columns)} emptyMessage={emptyMessage} sortColumn={sortColumn} sortDirection={sortDirection} sortAction={(newSortDirection, newSortColumn) => {changeSort(newSortDirection, newSortColumn)}}/>
        </div>
        <div className='pagination-controls'>
          <ResultsCount first={resultsFirstItem()} last={lastItem()} total={filteredItems.length} preFilterTotal={(users && filteredItems.length !== users.length) ? users.length : null}/>
          <div className='pagination'>
            <Pagination totalPages={totalPages} currentPage={currentPage} pagesToShow={3} changeFunction={setCurrentPage} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageUsers;
